import { ampli } from 'lib-shared-tracking';
import { PartnerTrackingEventsProps } from '../partners.types';

export const rivoLoyaltyPartnerTrackingEvents = ({
  partnerEvents,
}: PartnerTrackingEventsProps): void => {
  partnerEvents.on('rivoloyalty:customer:received', (payload) => {
    ampli.partnerIntegrationsRivoLoyaltyWidgetCustomerReceived(payload);
  });
  partnerEvents.on('rivoloyalty:customer:clicked', (payload) => {
    ampli.partnerIntegrationsRivoLoyaltyWidgetCustomerClicked(payload);
  });
  partnerEvents.on('rivoloyalty:points:add:succeeded', (payload) => {
    ampli.partnerIntegrationsRivoLoyaltyWidgetPointsAddSucceeded(payload);
  });
  partnerEvents.on('rivoloyalty:points:add:failed', (payload) => {
    ampli.partnerIntegrationsRivoLoyaltyWidgetPointsAddFailed(payload);
  });
  partnerEvents.on('rivoloyalty:points:remove:succeeded', (payload) => {
    ampli.partnerIntegrationsRivoLoyaltyWidgetPointsRemoveSucceeded(payload);
  });
  partnerEvents.on('rivoloyalty:points:remove:failed', (payload) => {
    ampli.partnerIntegrationsRivoLoyaltyWidgetPointsRemoveFailed(payload);
  });
};
